import { useState, useEffect } from 'react'

export const useTimer = ({ start, initialTimeLimit, onTimeout }) => {
  const [timeLeft, setTimeLeft] = useState(initialTimeLimit)

  useEffect(() => {
    let timer

    if (start && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(timeLeft - 1)
      }, 1000)
    } else if (timeLeft === 0) {
      clearInterval(timer)
      onTimeout()
    } else if (!start) {
      clearInterval(timer)
      setTimeLeft(initialTimeLimit)
    }

    return () => {
      if (timer) {
        clearInterval(timer)
      }
    }
  }, [start, timeLeft, initialTimeLimit])

  const stopTimer = () => {
    setTimeLeft(0)
  }

  return { timeLeft, stopTimer }
}
